import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Drawer,
  Typography,
  Divider,
  Grid,
  Box,
  Badge,
  Button,
} from "@material-ui/core";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import NotificationsIcon from "@material-ui/icons/Notifications";
import ListIcon from "@material-ui/icons/List";
import ListActions from "../components/shared/ListActions";
import { AuthService } from "../services/auth.service";
import { connect } from "react-redux";
import { actions } from "../redux/actions/alert";
import PersonIcon from "@material-ui/icons/Person";
import { Role } from "../_utils/roleEnum";
import { getRoleName } from "../_utils/utils";
import { withStyles } from "@material-ui/styles";
import { useHistory } from "react-router-dom";
import { connectSocketServer } from "../_config/socket";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  accountGrid: {
    paddingTop: "20px",
    paddingBottom: "10px",
  },
  userImage: {
    marginLeft: 20,
    fontSize: 70,
  },
  loginTitle: {
    color: " #262626",
    fontWeight: 500,
  },
  role: {
    color: " #f72222",
    fontWeight: 400,
    fontSize: 18,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    background: "white",
    overflowY: "hidden",
    overflowX: "hidden",
  },
  shoppingIcon: {
    margin: "10px 0px 10px 12px",
    "&:hover": {
      backgroundColor: "#b8bdf9",
    },
  },
}));

const StyledBadge = withStyles((theme) => ({
  badge: {
    right: -5,
    top: -5,
    padding: "0 8px",
  },
}))(Badge);

function RightMenuDrawer({ currentUser, isAdmin, shoppingCart: { cart } }) {
  const classes = useStyles();
  const history = useHistory();

  const [state, setState] = useState(false);
  const [name, setName] = useState("");
  const [socket] = useState(connectSocketServer());
  const [response, setResponse] = useState(undefined);

  const currentUserValue = AuthService.currentUserValue;

  useEffect(() => {
    if (currentUserValue) setName(currentUserValue.name);
  }, []);

  // useEffect(() => {
  //   socket.on("notification-channel-server", (resp) => {
  //     console.log("SOCKET resp", resp);
  //     if (Object.keys(resp).length) setResponse(4);
  //   });
  // }, [socket]);

  const toggleDrawer = (event) => {
    console.log("event", event?.type);
    if (
      event?.type === "keydown" &&
      (event?.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState(!state);
  };

  const getRole = () => {
    const userIdRole = Object.values(Role).filter(
      (role) => role === currentUserValue.roleId
    );
    return getRoleName(userIdRole[0]);
  };

  const getTotalItemsInCart = () =>
    Object.keys(cart).reduce((acc, sku) => acc + cart[sku].quantity, 0);

  const navigateToShoppingCart = () =>
    history.push("/dashboard/inventario/carrito");

  return (
    <div>
      <React.Fragment>
        <Grid container direction="row" justify="center" alignItems="center">
          {currentUserValue && currentUserValue.roleId === Role.Seller && (
            <>
              <Grid item>
                <Button
                  className={classes.shoppingIcon}
                  onClick={navigateToShoppingCart}
                >
                  <StyledBadge
                    badgeContent={getTotalItemsInCart()}
                    color="error"
                  >
                    <ShoppingCartIcon color="primary" />
                  </StyledBadge>
                </Button>
              </Grid>
              <Grid item>
                <Button className={classes.shoppingIcon}>
                  <StyledBadge badgeContent={response} color="error">
                    <NotificationsIcon color="primary" />
                  </StyledBadge>
                </Button>
              </Grid>
              <Grid item>{response || ""}</Grid>
            </>
          )}
          <Grid item>
            <Button
              className={classes.shoppingIcon}
              onClick={(e) => toggleDrawer(e)}
            >
              <ListIcon color="primary" />
            </Button>
          </Grid>
        </Grid>

        <Drawer
          classes={{ paper: classes.drawerPaper }}
          anchor={"right"}
          open={state}
          onClose={(e) => toggleDrawer(e)}
        >
          <Grid container spacing={4} className={classes.accountGrid}>
            <Grid item sm={4} md={4} lg={4}>
              <PersonIcon htmlColor="#668cff" className={classes.userImage} />
            </Grid>
            {currentUserValue && (
              <Grid item sm={7} md={8} lg={8}>
                <Typography
                  variant="h6"
                  component="h5"
                  className={classes.loginTitle}
                >
                  <Box mb={1}>{name}</Box>
                </Typography>
                <Typography
                  className={classes.role}
                  style={{ marginBottom: 20 }}
                >
                  {getRole()}
                </Typography>
              </Grid>
            )}
          </Grid>
          <Divider></Divider>
          <ListActions openDrawer={toggleDrawer}></ListActions>
        </Drawer>
      </React.Fragment>
    </div>
  );
}

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

const mapStateToProps = (state) => ({
  shoppingCart: state.shoppingCart,
});

export default connect(mapStateToProps, dispatch)(RightMenuDrawer);
